import userTypes from './user.types'

const INITIAL_STATE = {
	currentUser: null,
	resetPasswordSuccess: false,
	// updateUserSuccess: false,
	userErr: [],
	customers: [],
	vendors: []
}

const userReducer = (state = INITIAL_STATE, action) => {
	switch(action.type){
		case userTypes.SIGN_IN_SUCCESS:
			return {
			  ...state,
			  currentUser: action.payload,
			  userErr: []
			}
	
		case userTypes.RESET_PASSWORD_SUCCESS:
			return {
				...state,
				resetPasswordSuccess: action.payload
			}
		
		case userTypes.SET_CUSTOMERS:
			return {
				...state,
				customers: action.payload
			}
		case userTypes.SET_VENDORS:
			return {
				...state,
				vendors: action.payload
			}
	
		case userTypes.USER_ERROR:
			return {
				...state,
				userErr: action.payload
			}
		case userTypes.RESET_USER_STATE:
			return {
				...state,
				...INITIAL_STATE
			}
		case userTypes.SIGN_OUT_USER_SUCCESS:
			return {
				...state,
				...INITIAL_STATE
			}
		default:
			return state;
	}
};

export default userReducer